<template>
  <EditablePanel
    class="InvoiceAddressPanel"
    :title="title"
    :editable="editable"
    :disabled="disabled"
    :isLoading="isLoading"
    @edit="$emit('edit')"
    @save="$emit('save')"
  >
    <div class="invoice-type-container" v-if="emptyAddress || editable ">
      <div class="invoice-option font-size-middle">
        <label>
          <input
            :checked="invoiceType === 'private'"
            class="inputInvoice"
            type="radio"
            name="invoice-type"
            value="private"
            @click="updateInvoiceType('private')"
          />
          Osoba prywatna
          <span class="bullet"></span>
        </label>
      </div>
      <div class="invoice-option font-size-middle">
        <label>
          <input
            :checked="invoiceType === 'company'"
            class="inputInvoice"
            type="radio"
            name="invoice-type"
            value="company"
            @click="updateInvoiceType('company')"
          />
          Firma
          <span class="bullet"></span>
        </label>
      </div>
    </div>
    <div
      class="fields font-size-middle"
      v-bind:class="{ 'field-company': invoiceType === 'company' }"
    >
      <HybridInput
        :editable="emptyAddress || editable "
        v-if="invoiceType === 'company'"
        class="field company-name"
        v-model="address.companyName"
        placeholder="Nazwa firmy"
      />
      <HybridInput
        :editable="emptyAddress || editable "
        v-if="invoiceType === 'private'"
        class="field name"
        v-model="address.name"
        placeholder="imię"
      />
      <HybridInput
        :editable="emptyAddress || editable "
        v-if="invoiceType === 'private'"
        class="field surname"
        v-model="address.surname"
        placeholder="nazwisko"
      />
      <HybridInput
        :editable="emptyAddress || editable "
        class="field street"
        v-model="address.street"
        placeholder="ulica"
      />
      <HybridInput
        :editable="emptyAddress || editable "
        class="field post"
        v-model="address.postCode"
        placeholder="kod pocztowy"
        :distinctive="true"
        :validator="'postCode'" 
        :invalid="invalidAddress.postCode"
        :pattern="'\\d{2}-\\d{3}'"
        :title="'Prawidłowy format to XX-XXX'"
      />
      <HybridInput
        :editable="emptyAddress || editable "
        class="field city"
        v-model="address.city"
        placeholder="miasto"
      />
      <HybridInput
        :editable="emptyAddress || editable "
        v-if="invoiceType === 'company'"
        class="field company-nip"
        v-model="address.NIP"
        placeholder="NIP"
      />
    </div>
  </EditablePanel>
</template>

<script>
import EditablePanel from "./EditablePanel.vue";
import HybridInput from "./HybridInput.vue";

export default {
  name: "InvoiceAddressPanel",
  components: {
    EditablePanel,
    HybridInput,
  },
  props: {
    editable: {
      type: Boolean,
      default: false,
      required: true,
    },
    address: {
      default: function () {
        return {
          name: "",
          surname: "",
          street: "",
          postCode: "",
          city: "",
          isCompany: "",
        };
      },
      required: false,
    },
    title: {
      default: "",
      required: false,
    },
    emptyAddress: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      invoiceType: this.address.isCompany ? 'company' : 'private',
      invalidAddress: {
        postCode: false
      }
    };
  },
  methods: {
    updateInvoiceType(type) {
      this.invoiceType = type;
      if (this.address.isCompany) {
        this.address.isCompany = false
      } else {
        this.address.isCompany = true
      }
    },
  },
  mounted () {
    if(this.emptyAddress){
      this.editable = true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/globals.scss";

.InvoiceAddressPanel {
  .invoice-type-container {
    display: grid;
    grid-template-columns: 1fr 0.6fr;
    grid-template-rows: 1fr 1fr;
    padding-top: 25px;

    .invoice-option {
      position: relative;

      &:first-child {
        justify-self: center;
      }

      input {
        opacity: 0;
      }

      .bullet::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 12px;
        height: 12px;
        border: 2px solid white;
        background-color: white;
        border-radius: 50%;
        cursor: pointer;
      }
      .bullet::after {
        content: "";
        position: absolute;
        left: 4px;
        top: 50%;
        transform: translateY(-50%);
        width: 8px;
        height: 8px;
        background-color: $primary;
        border-radius: 50%;
        opacity: 0;
        cursor: pointer;
      }

      .inputInvoice:checked + .bullet::before {
        border-color: $primary;
      }
      .inputInvoice:checked + .bullet::after {
        opacity: 1;
      }
    }
  }

  .fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: repeat(7, 1fr);
    grid-gap: 0 50px;
    height: 252px;

    .company-name {
      grid-column: 1 / 3;
    }

    .company-name {
      grid-column: 1 / 3;
    }

    .name {
      grid-column: 1 / 2;
    }

    .surname {
      grid-column: 2 / 3;
    }

    .street {
      grid-column: 1 / 3;
    }

    .post {
      grid-column: 1 / 3;
    }

    .city {
      grid-column: 1 / 3;
    }

    .field {
      margin-bottom: 0;
    }
  }

  .field-company {
    grid-template-columns: 1fr;
    grid-gap: 0;
    height: 315px;
  }
}
</style>
